module.exports = __webpack_public_path__ + "static/media/MLA-3.6cec1045.png";